// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"contracts_breadcrumbs__AT9DP"};